module.exports = __webpack_public_path__ + "img/Annotated_Ancient_Prison_Map.2cfdccf8.png";